import React, { useRef, useEffect } from 'react';
import { X } from 'lucide-react';

const styles = {
  container: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '10px',
    padding: '10px 16px',
    background: '#fff',
    borderTop: '1px solid #E8EBF2',
  },
  textareaWrapper: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  label: {
    fontSize: '11px',
    color: '#0866FF',
    fontWeight: '700',
    marginBottom: '6px',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  textarea: {
    width: '100%',
    padding: '10px 12px',
    background: '#F9FAFB',
    border: '1px solid #E5E7EB',
    borderRadius: '8px',
    color: '#1F2937',
    fontSize: '14px',
    resize: 'none',
    height: '63px',
    outline: 'none',
    fontFamily: 'inherit',
    lineHeight: '1.5',
    overflowY: 'auto',
    boxSizing: 'border-box',
  },
  closeBtn: {
    background: '#F1F5F9',
    border: 'none',
    color: '#6B7280',
    cursor: 'pointer',
    padding: '8px',
    borderRadius: '6px',
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    marginTop: '22px',
  },
};

export default function EditZone({ text, onChange, onClose }) {
  const textareaRef = useRef(null);

  // Focus, scroll to bottom, and place cursor at end on mount
  useEffect(() => {
    const el = textareaRef.current;
    if (el) {
      el.focus();
      // Scroll to bottom so latest text is visible
      el.scrollTop = el.scrollHeight;
      // Place cursor at the end of text
      el.selectionStart = el.value.length;
      el.selectionEnd = el.value.length;
    }
  }, []);

  return (
    <div style={styles.container}>
      <div style={styles.textareaWrapper}>
        <div style={styles.label}>Edit Zone</div>
        <textarea
          ref={textareaRef}
          style={styles.textarea}
          value={text}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Edit the transcript or type your message..."
          rows={3}
          autoFocus
        />
      </div>
      <button style={styles.closeBtn} onClick={onClose} title="Close edit zone">
        <X size={16} />
      </button>
    </div>
  );
}
